import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import TicketAlertToast from '../TicketAlertToast';

export default function MainLayout() {
  return (
    <div className="layout">
      <Sidebar />
      <div className="layout__main">
        <Header />
        <main className="layout__content">
          <Outlet />
        </main>
      </div>
      <TicketAlertToast />

      <style>{`
        .layout {
          display: flex;
          min-height: 100vh;
        }

        .layout__main {
          flex: 1;
          /* Sidebar now floats inset by --shell-gap on each side (see
             Sidebar.jsx), so content starts past its right edge plus
             another gap, instead of right at --sidebar-width. */
          margin-left: calc(var(--sidebar-width) + (var(--shell-gap) * 2));
          display: flex;
          flex-direction: column;
          transition: margin-left var(--duration-base) var(--ease-out);
        }

        /* No overflow here: this box is never height-limited, so it never
           scrolled — the page does — but as a scroll area it stopped any
           position: sticky inside a page (the ticket queue's column headings)
           from sticking to the screen. */
        .layout__content {
          flex: 1;
          padding: var(--space-8);
        }

        /* Handle collapsed sidebar */
        .sidebar--collapsed ~ .layout__main,
        .sidebar--collapsed + .layout__main {
          margin-left: calc(var(--sidebar-collapsed) + (var(--shell-gap) * 2));
        }

        @media (max-width: 1024px) {
          .layout__main {
            margin-left: 0;
          }
          
          .layout__content {
            padding: var(--space-5);
          }
        }
      `}</style>
    </div>
  );
}
